export const getCampaignUrl = (
  trackingID?: string | null,
  campaignID?: string | null,
  countryID?: number | string | null,
): string => {
  const baseUrl = window.location.origin;
  const parts = trackingID ? trackingID.split('_') : [];

  if (parts[0] === 'ts') {
    // Trident tracking IDs are ts_<campaign_id>_<schedule_id>[_<updated_at>_<schedule_start_time>]; the country only comes from campaign.country_id.
    const entityID = parts[1];
    if (entityID && countryID) {
      return `${baseUrl}/campaigns/${countryID}/${entityID}/view`;
    }
  } else if (parts.length === 3 && parts.every(Boolean)) {
    const [projectId, campaignId] = parts;
    return `${baseUrl}/ucd/project/${projectId}/campaign/${campaignId}/smart-comms/view?previousPageIsListing=true`;
  }

  if (campaignID) {
    return `${baseUrl}/ucd/campaign/${campaignID}`;
  }

  return '';
};
